export default "/images/video.png?f1264c03315253e83fc520dfff11221c";